<div class="form-group">
    <div class="row fields-group">
        <div class="col-auto">
            <label class="input-label">{{ 'dets.predicate' | translate }}</label>
            <select class="form-control"
                    [(ngModel)]="operator"
                    (ngModelChange)="operatorValueChanged()">
                <option *ngFor="let o of operators" [ngValue]="o">{{ o | translate }}</option>
            </select>
        </div>
        <div class="col mt-3 pt-4" *ngIf="!isOperatorIsValid()">
            <label class="ui-checkbox input-label">
                <input class="form-control" name="current-date" type="checkbox" value="{{isCurrentDate}}"
                       [(ngModel)]="isCurrentDate" (ngModelChange)="isCurrentDateChanged()">
                <span>{{ 'dets.currentDate' | translate }}</span>
            </label>
        </div>
    </div>
    <div class="row fields-group" *ngIf="!isOperatorIsValid()">
        <div *ngIf="!isCurrentDate" class="col-md-12 col-12 mt-2 field-determinant-question-date">
            <label class="input-label">{{ 'dets.predicate_value' | translate }}</label>
            <input type="text"
                   [(ngModel)]="dateValue"
                   (ngModelChange)="dateValueChanged($event)"
                   class="form-control"
                   bsDatepicker>
            <label class="input-label">{{ 'dets.comparison_field_label' | translate }}</label>
            <search-select *ngIf="fields.length > 0"
                    (change)="onTargetFormFieldKeyChange($event)"
                    [items]="fields"
                    [selected]="sourceFormFieldKey"
                    [placeholder]="'Choose here' | translate"></search-select>
        </div>
    </div>
</div>
